import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import style from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.SectionB');
    const { locale } = getLocal();
    return (
        <div className={`${style.comp} GtmModuleData-section`} id="SectionB" data-section-id="SectionB" data-section-title={t('title') || t('module-title')}>
            {locale === 'jp' && (
                <>
                    <EcoSpace />
                    <EcoTitle className="jp-title" title={t('module-title')} />
                </>
            )}
            <EcoSpace />
            <EcoSectionCard
                className="sectionb-card"
                layout="img-right"
                isVideo={true}
                label={t('label')}
                title={t('title')}
                desc={t.rich('desc', {
                    sup: (v: string) => <sup>{v}</sup>,
                    ps: (v: string) => <span className="sub">{v}</span>,
                })}
                poster={
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1745223593664/video2.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1744880265393/%E8%A7%86%E9%A2%912.jpg'
                }
                pc={
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/video/1745222619613/video2.mp4'
                        : 'https://websiteoss.ecoflow.com/upload/video/1744880134860/video2.mp4'
                }
            />
            {locale !== 'jp' && <EcoSpace />}
        </div>
    );
}
